// src/pages/LoginPage.js
import * as React from 'react';
import { useState } from 'react';
import { useLogin, Notification, useNotify } from 'react-admin';
import {
    Avatar, Box, Button, Container, CssBaseline, TextField, Typography, Paper
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export default function LoginPage() {
    const login = useLogin();     // appelle authProvider.login
    const notify = useNotify();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const username = data.get('username');
        const password = data.get('password');
        setLoading(true);
        try {
            await login({ username, password }); // RA redirige automatiquement vers la page précédente (ou /)
        } catch (err) {
            notify(err?.message || 'Échec de connexion', { type: 'warning' });
            setLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Paper elevation={3} sx={{ mt: 8, p: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Avatar sx={{ m: 1 }}>
                        <LockIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Connexion admin
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="Identifiant"
                            name="username"
                            autoComplete="username"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Mot de passe"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading}
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Se connecter
                        </Button>
                    </Box>
                </Box>
            </Paper>
            <Notification />
        </Container>
    );
}
